export default "/images/vendor/@coreui/icons/svg/flag/cif-pt.svg?10c835e273b9b550f118bea4134a8f54";